import * as React from 'react';

export const krFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_309)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_309'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_309)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18.6667 10C18.6667 12.5773 16.5773 14.6667 14 14.6667C11.4227 14.6667 9.33334 12.5773 9.33334 10C9.33334 8.50667 12.4667 7.88 15.104 8.116C15.384 8.04133 15.6853 8 16 8C17.4733 8 18.6667 8.896 18.6667 10Z'
                    fill='#0047A0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M13.3333 9.33333C13.3333 9.33333 14.5267 7.99999 16 7.99999C17.4733 7.99999 18.6667 8.89599 18.6667 10C18.6667 7.42266 16.5773 5.33333 14 5.33333C12.1373 5.33333 10.5293 6.42399 9.78134 8.00266C9.33334 9.33333 9.33334 9.72266 9.33334 10C10 10.6667 10.7413 10.6667 11.3333 10.6667C11.9253 10.6667 12.4573 10.4093 12.824 10L13.3333 9.33333Z'
                    fill='#CD2E3A'
                />
                <mask
                    id='mask1_1_309'
                    style={{ maskType: 'luminance' }}
                    maskUnits='userSpaceOnUse'
                    x='-1'
                    y='0'
                    width='30'
                    height='20'
                >
                    <path
                        d='M-0.33366 0.467941H28.3288V19.5321H-0.33366V0.467941Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask1_1_309)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M-0.33366 0.467941H28.333V19.5321H-0.33366V0.467941Z'
                        fill='#F1F5F9'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M18.6667 10C18.6667 12.5773 16.5773 14.6667 14 14.6667C11.4227 14.6667 9.33333 12.5773 9.33333 10C9.33333 8.50667 12.4667 7.88 15.104 8.116C15.384 8.04133 15.6853 8 16 8C17.4733 8 18.6667 8.896 18.6667 10Z'
                        fill='#0047A0'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M13.3333 9.33334C13.3333 9.33334 14.5267 8.00001 16 8.00001C17.4733 8.00001 18.6667 8.89601 18.6667 10C18.6667 7.42268 16.5773 5.33334 14 5.33334C12.1373 5.33334 10.5293 6.42401 9.78133 8.00268C9.33333 9.33334 9.33333 9.72268 9.33333 10C9.99999 10.6667 10.7413 10.6667 11.3333 10.6667C11.9253 10.6667 12.4573 10.4093 12.824 10L13.3333 9.33334Z'
                        fill='#CD2E3A'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M4.26042 6.26826L6.91638 2.32232L7.54892 2.7403L4.89295 6.68625L4.26042 6.26826ZM5.20922 6.89524L7.86518 2.94929L8.49772 3.36727L5.84175 7.31322L5.20922 6.89524ZM6.15802 7.52221L8.81398 3.57626L9.44652 3.99424L6.79055 7.94019L6.15802 7.52221Z'
                        fill='#000008'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M18.5195 15.7778L21.1755 11.8318L21.808 12.2498L19.1521 16.1958L18.5195 15.7778ZM19.4683 16.4047L22.1243 12.4588L22.7568 12.8768L20.1009 16.8227L19.4683 16.4047ZM20.4171 17.0317L23.0731 13.0858L23.7056 13.5037L21.0497 17.4497L20.4171 17.0317Z'
                        fill='#000008'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M19.4925 13.56L22.7332 15.7213L19.4925 13.56Z'
                        fill='#000008'
                    />
                    <path
                        d='M19.4925 13.56L19.3851 13.721L22.6258 15.8823L22.7332 15.7213L22.8406 15.5603L19.5999 13.399L19.4925 13.56Z'
                        fill='#F1F5F9'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M6.92741 17.4512L4.27145 13.5053L4.90398 13.0873L7.55994 17.0332L6.92741 17.4512ZM7.87621 16.8242L5.22025 12.8783L5.85278 12.4603L8.50874 16.4063L7.87621 16.8242ZM8.82501 16.1973L6.16905 12.2513L6.80158 11.8334L9.45754 15.7793L8.82501 16.1973Z'
                        fill='#000008'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M21.1865 7.94176L18.5306 3.99581L19.1631 3.57783L21.8191 7.52378L21.1865 7.94176ZM22.1353 7.31479L19.4794 3.36884L20.1119 2.95086L22.7679 6.89681L22.1353 7.31479ZM23.0841 6.68782L20.4282 2.74187L21.0607 2.32389L23.7167 6.26984L23.0841 6.68782Z'
                        fill='#000008'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M6.37825 14.9664L7.35046 14.3181L6.37825 14.9664ZM19.5031 6.21326L20.6373 5.45682L19.5031 6.21326ZM21.6096 4.80843L22.5818 4.16005L21.6096 4.80843Z'
                        fill='#000008'
                    />
                    <path
                        d='M6.37825 14.9664L6.48564 15.1275L7.45785 14.4791L7.35046 14.3181L7.24308 14.157L6.27087 14.8054L6.37825 14.9664ZM19.5031 6.21326L19.6105 6.37428L20.7447 5.61784L20.6373 5.45682L20.53 5.29579L19.3957 6.05224L19.5031 6.21326ZM21.6096 4.80843L21.7169 4.96945L22.6892 4.32107L22.5818 4.16005L22.4744 3.99903L21.5022 4.64741L21.6096 4.80843Z'
                        fill='#F1F5F9'
                    />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_309'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
